import alt from 'components/Dispatcher';
import { hashHistory } from 'react-router';
class TeamActions{
  fetchTeams(params){
    return params;
  }
  fetchTeamStarts(params){
    return params;
  }
  updateTeams(teams) {
    return teams;
  }
  updateTeamStarts(starts) {
    return starts;
  }
  updateDay(date){
    return date;
  }
  refreshTeam(){
    return true;
  }
  fetchLoading() {
    return {loading: true};
  }
  fetchSuccess(res) {
    if(res.status) {
      this.fetchError(res);
    } else {
      this.updateTeams(res.result);
    }
    return true;
  }
  fetchStartSuccess(res) {
    if(res.status) {
      this.fetchError(res);
    } else {
      this.updateTeamStarts(res.result);
    }
    return true;
  }
  fetchError(res) {
    if(res.status === 403) {
      hashHistory.push('/login');
    }
    return res;
  }
}

export default alt.createActions(TeamActions);



// WEBPACK FOOTER //
// ./src/actions/TeamActions.js